var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"next-available-call-table"},[_c('b-table',{attrs:{"fixed":"","hover":"","show-empty":"","items":_vm.calls,"fields":_vm.callFields,"empty-text":"No calls available"},scopedSlots:_vm._u([{key:"cell(client)",fn:function(ref){
var item = ref.item;
return [_vm._v("\n            "+_vm._s(_vm.clientName(item))+"\n        ")]}},{key:"cell(partnerPractice)",fn:function(ref){
var item = ref.item;
return [_vm._v("\n            "+_vm._s(_vm.partnerPracticeName(item.partnerPracticeId))+"\n        ")]}},{key:"cell(originalSource)",fn:function(ref){
var item = ref.item;
return [_vm._v("\n            "+_vm._s(_vm.originalSourceDescription(item.originalSourceId))+"\n        ")]}},{key:"cell(date)",fn:function(ref){
var item = ref.item;
return [_vm._v("\n            "+_vm._s(_vm._f("date")(item.date))+"\n        ")]}},{key:"cell(time)",fn:function(ref){
var item = ref.item;
return [_vm._v("\n            "+_vm._s(_vm._f("time")(item.date))+"\n        ")]}},{key:"cell(type)",fn:function(ref){
var item = ref.item;
return [_c('b-badge',{attrs:{"variant":"primary"}},[_vm._v(_vm._s(_vm.callTypeText(item.type)))]),_c('b-badge',{attrs:{"variant":"info"}},[_vm._v(_vm._s(_vm.callReasonText(item.reason)))])]}},{key:"cell(actions)",fn:function(ref){
var item = ref.item;
return [_vm._t("actions",null,{"call":item})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }